import React, { useEffect } from 'react';

import * as emailTemplatesSlice from '@features/emailTemplatesSlice';
import * as emailsSlice from '@features/emailsSlice';
import * as formsSlice from '@features/formsSlice';
import * as landingPageTemplatesSlice from '@features/landingPageTemplatesSlice';
import * as landingPagesSlice from '@features/landingPagesSlice';
import * as programsSlice from '@features/programsSlice';
import * as snippetsSlice from '@features/snippetsSlice';
import { useAppDispatch } from '@store';

import styles from './style.module.scss';

const CampaignsOrder: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(programsSlice.uncheckAll());
      dispatch(emailTemplatesSlice.uncheckAll());
      dispatch(emailsSlice.uncheckAll());
      dispatch(formsSlice.uncheckAll());
      dispatch(landingPageTemplatesSlice.uncheckAll());
      dispatch(landingPagesSlice.uncheckAll());
      dispatch(snippetsSlice.uncheckAll());

      dispatch(programsSlice.setQuery(''));
      dispatch(emailTemplatesSlice.setQuery(''));
      dispatch(emailsSlice.setQuery(''));
      dispatch(formsSlice.setQuery(''));
      dispatch(landingPageTemplatesSlice.setQuery(''));
      dispatch(landingPagesSlice.setQuery(''));
      dispatch(snippetsSlice.setQuery(''));
    };
  });

  return (
    <>
      <header className={styles.header}>
        <h2>Order successful</h2>
      </header>
      <div className={styles.container}>
        <p>You will receive a link to track the progress on TOS in Asana</p>
      </div>
    </>
  );
};

export default CampaignsOrder;
